import React, { useEffect, useState } from 'react';
import {
  RiCheckboxBlankCircleLine,
  RiCheckboxCircleLine,
} from 'react-icons/ri';

function HasReviews({ onFilter, hasReviews }) {
  const [checked, setChecked] = useState(hasReviews);

  useEffect(() => {
    setChecked(hasReviews);
  }, [hasReviews]);

  return (
    <button
      className={`hotels__reviews-filter ${
        checked ? 'hotels__reviews-filter_active' : ''
      }`}
      onClick={() => {
        onFilter(!checked);
        setChecked(!checked);
      }}
      title="Отфильтровать отели с нашими отзывами"
    >
      <span>Отели с нашими отзывами</span>
      {checked ? <RiCheckboxCircleLine /> : <RiCheckboxBlankCircleLine />}
    </button>
  );
}

export default HasReviews;
